import type { StorageType } from '../types/Storage';

const COOKIE_STORAGE: StorageType = 'cookieStorage';
const LOCAL_STORAGE: StorageType = 'localStorage';
const SESSION_STORAGE: StorageType = 'sessionStorage';
const MEMORY_STORAGE: StorageType = 'memoryStorage';
const NO_STORAGE: StorageType = 'none';

export { COOKIE_STORAGE, LOCAL_STORAGE, SESSION_STORAGE, MEMORY_STORAGE, NO_STORAGE };
